import { DispositiveProvisions_BeneficiaryDesignationsFragment } from '@/modules/dispositiveProvisions/graphql/DispositiveProvisions.fragments.generated';

import { EntityPresentation_EntityFragment } from '../../graphql/EntityPresentation.generated';

/** Returns null for non-retirement / non-DH-insurance subtypes. */
export function getBeneficiaryDesignationsFromEntity(
  entity: Pick<
    EntityPresentation_EntityFragment,
    'beneficiaryDesignationsSubtype'
  >
): DispositiveProvisions_BeneficiaryDesignationsFragment | null {
  const subtype = entity.beneficiaryDesignationsSubtype;
  if (!subtype) return null;

  if (
    subtype.__typename === 'RetirementPersonalAccount' ||
    subtype.__typename === 'InsurancePersonalAccount'
  ) {
    return subtype.beneficiaryDesignations ?? null;
  }

  return null;
}
